import { TrendingUp, Clock, Wand2, BarChart3, Users, Shield } from "lucide-react";

const BenefitsSection = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: "Increase Click-Through Rate",
      description: "Our AI-generated thumbnails are optimized for maximum CTR. Users report an average 2.5x increase in clicks.",
      stat: "2.5x",
      statLabel: "CTR Boost",
    },
    {
      icon: Clock,
      title: "Save Time & Money",
      description: "Stop spending hours on design or paying expensive designers. Create pro thumbnails in under 60 seconds.",
      stat: "60s",
      statLabel: "Per Thumbnail",
    },
    {
      icon: Wand2,
      title: "No Design Skills Needed",
      description: "Forget Photoshop or Canva. Our AI handles all the design work while you focus on creating content.",
      stat: "0",
      statLabel: "Skills Required",
    },
    {
      icon: BarChart3,
      title: "Algorithm Optimized",
      description: "Thumbnails designed based on YouTube's algorithm preferences and what actually gets clicked.",
      stat: "10M+",
      statLabel: "Data Points",
    },
    {
      icon: Users,
      title: "Stand Out From Competition",
      description: "Get unique, eye-catching designs that make viewers stop scrolling and click on your videos.",
      stat: "100%",
      statLabel: "Unique Designs",
    },
    {
      icon: Shield,
      title: "Copyright-Safe Designs",
      description: "All generated thumbnails are original and safe to use. No copyright issues, guaranteed.",
      stat: "100%",
      statLabel: "Original",
    },
  ];

  return (
    <section className="section-padding relative">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-semibold text-brand-blue uppercase tracking-wider mb-4 block">
            Why ThumbGenius
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Everything You Need to{" "}
            <span className="gradient-text">Grow Your Channel</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands of creators who've transformed their YouTube presence with AI-powered thumbnails.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative p-8 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-300 overflow-hidden"
            >
              {/* Gradient Background on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative z-10">
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                  <benefit.icon className="w-6 h-6 text-brand-purple" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                  {benefit.description}
                </p>

                {/* Stat */}
                <div className="flex items-baseline gap-2">
                  <span className="text-3xl font-bold gradient-text">{benefit.stat}</span>
                  <span className="text-sm text-muted-foreground">{benefit.statLabel}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
